module.exports = __webpack_public_path__ + "img/joinus-5.cc249ef4.png";